

import { mapState } from "vuex";

export default {
  data() {
    return {

    }
  },
  computed: {
    ...mapState(["userModule"]),
  },
  mounted() {
    // console.log(this.userModule.fileUrl)
  },
  watch: {
    "userModule.id": {
      handler: function (n, o) {
        this.init();
      },
    },
    "userModule.filePath": {
      handler: function (n, o) {
        this.init();
      },
    },
    "userModule.fileUrl": {
      immediate: true,
      handler: function (n, o) {
        if (n) {
          this.init();
        }
      },
    }
  },

};



// WEBPACK FOOTER //
// ./src/minxins/role.js